import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetValidatetateApplicationInformationPage = createAsyncThunk(
  "InformationAboutProject/ValidatetateApplicationInformationPage",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutProject/ValidatetateApplicationInformationPage",
        {
            aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
      return arrayValidate; // Return the extracted data

    }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);

    }
  }
);

const ApplicationInformationValidationPage = createSlice({
  name: "ApplicationInformationValidationPage",
  initialState: {
    ApplicationInformationValidationPage: [],
    loadingApplicationInformationValidationPage: false,
    errorApplicationInformationValidationPage: null,
  },
  reducers: {
    SetApplicationInformationValidationPage: (state, action) => {
      state.ApplicationInformationValidationPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetValidatetateApplicationInformationPage.pending, (state, action) => {
        state.loadingApplicationInformationValidationPage = true;
        state.ApplicationInformationValidationPage = action.payload;
        state.errorApplicationInformationValidationPage = null;
      })
      .addCase(GetValidatetateApplicationInformationPage.fulfilled, (state, action) => {
        state.loadingApplicationInformationValidationPage = false;
        state.ApplicationInformationValidationPage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetValidatetateApplicationInformationPage.rejected, (state, action) => {
        state.loadingApplicationInformationValidationPage = false;
        state.errorApplicationInformationValidationPage = action.payload;
      });
  },
});
export const { SetApplicationInformationValidationPage } = ApplicationInformationValidationPage.actions

export default ApplicationInformationValidationPage.reducer;
